/**
 * This function searches through a list of chapters and their sub-chapters to find the level of a chapter by its ID.
 *
 * @param {Chapter[]} chapters - The list of chapters to search through.
 * @param {string} id - The ID of the chapter to find.
 * @param {number} [level=0] - The current level of recursion, defaults to 0.
 * @returns {number | null} - The level of the chapter if found, otherwise null.
 *
 * Usage:
 * const level = findChapterLevelById(chapters, 'chapterId');
 * if (level !== null) {
 *   console.log(`Chapter found at level ${level}`);
 * } else {
 *   console.log('Chapter not found');
 * }
 */

import { Chapter } from "graphql/types"

export const findChapterLevelById = (
  chapters: Chapter[],
  id: string,
  level: number = 0
): number | null => {
  for (const chapter of chapters) {
    if (chapter.id === id) {
      return level
    }
    if (chapter.subChapter && chapter.subChapter.length > 0) {
      const foundLevel = findChapterLevelById(chapter.subChapter, id, level + 1)
      if (foundLevel !== null) {
        return foundLevel
      }
    }
  }
  return null
}
